import React from 'react';
import { Box, Stack } from '@mui/material';
import { Card } from '@travelity/ui/card';

import { List } from '@components/list-layout';

export interface PaymentProviderCardProps {
    children: React.ReactNode;
    loading: boolean;
    isLoading?: boolean;
}

export const PaymentProviderCard: React.FC<PaymentProviderCardProps> = ({
    children,
    loading,
    isLoading,
}) => {
    return (
        <List>
            <Box
                sx={{
                    flexGrow: 2,
                    mx: 2,
                    my: { xs: 0, sm: 2 },
                    px: 2,
                    height: { xs: '100%', sm: 'calc(100% - 32px)' },
                    minWidth: '320px',
                    overflow: isLoading ? 'hidden' : 'initial',
                }}
            >
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    gap={2}
                    py={2}
                >
                    <Card
                        parentProps={{ maxWidth: '520px', width: '100%' }}
                        loadingOverlay={loading}
                    >
                        {children}
                    </Card>
                </Stack>
            </Box>
        </List>
    );
};
